<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6946_206841)">
      <path
        d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
        fill="#DC2626"
      />
      <path
        d="M11.107 0.5H4.893L0.5 4.893V11.107L4.893 15.5H11.107L15.5 11.107V4.893L11.107 0.5Z"
        stroke="#DC2626"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M8 3.5V9" stroke="#DC2626" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_6946_206841">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
